export function buildGnbByUiCode (uiCode) {
  return {
    'title': 'GnbTemplate',
    'uicode': `${uiCode}`,
    'eventlist': [
      {
        'type': 'on-click',
        'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 홈 화면 메뉴를 클릭 함)',
        'url': 'uievent3.wavve.com/uievent',
        'method': 'post',
        'bodylist': [
          'type:click',
          'uirank:1',
          'uiparent:none',
          `uicode:${uiCode}`,
          'timestamp:$TIMESTAMP'
        ],
        'add_common_params': 'y',
        'add_credential': 'y'
      },
      {
        'type': 'on-content',
        'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 홈 화면)',
        'url': `apis.wavve.com/v1/multiband/${uiCode}`,
        'add_common_params': 'y',
        'add_credential': 'y'
      }
    ]
  }
}
